import { cn } from "~/lib/utils";

interface Props {
  className?: string;
}

export default function ReshopLogo({ className }: Props) {
  return (
    <img
      src="/images/logo_salmon.png"
      alt="Reshop logo"
      className={cn("w-20", className)}
    />
  );
}
